module.exports = __webpack_public_path__ + "img/45d5d057f34a816885338dd7c2c66046.png";